import {userService} from "../../client/connection/services/UserService";
import {Messages} from "../../blinkpay/Messages";

export function getPaymentMethodEmptySubscriptionMessage(subscription) {
    return subscription.billedUser === userService.getUser() ?
        Messages.noPaymentMethodForThisSubscription :
        Messages.noPaymentMethodForThisSubscriptionGifted;
}
